import { buildEditorSections } from "@/lib/phone-json-labels";
import { cn } from "@/lib/utils";

export function SectionNav({
  root,
  activePath,
  onSelect,
}: {
  root: unknown;
  activePath: string;
  onSelect: (path: string) => void;
}) {
  const sections = buildEditorSections(root);
  let lastGroup: string | undefined;

  return (
    <nav className="flex h-full min-h-0 w-44 shrink-0 flex-col gap-0.5 overflow-y-auto border-r border-border pr-2">
      {sections.map((section) => {
        const showGroup = section.group && section.group !== lastGroup;
        if (section.group) lastGroup = section.group;
        const active = activePath === section.path;
        return (
          <div key={section.id}>
            {showGroup ? (
              <p className="mb-0.5 mt-2 px-2 text-[0.65rem] font-medium tracking-wide text-muted-foreground first:mt-0">
                {section.group}
              </p>
            ) : null}
            <button
              type="button"
              onClick={() => onSelect(section.path)}
              className={cn(
                "flex w-full items-center justify-between gap-1 rounded-md px-2 py-1 text-left text-xs transition-colors",
                active
                  ? "bg-muted font-medium text-foreground"
                  : "text-muted-foreground hover:bg-muted/60 hover:text-foreground",
              )}
            >
              <span className="truncate">{section.label}</span>
              {section.count != null ? (
                <span className="shrink-0 tabular-nums text-[0.65rem] text-muted-foreground">
                  {section.count}
                </span>
              ) : null}
            </button>
          </div>
        );
      })}
    </nav>
  );
}
